module.exports = __webpack_public_path__ + "static/media/6-icon.f5b04a2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/brand/6-icon.svg
// module id = 703
// module chunks = 0